import React, { useEffect } from "react";
import Nav from "./Nav";
import Reactplayer from "./ReactPlayer";
import AOS from "aos";
import "aos/dist/aos.css";
import { CheckIcon, XIcon } from "@heroicons/react/outline";
// import { Link } from "react-router-dom";
import Price from "./Price";
import OurClientsResults from "./OurClientsResults";
import DatePicker from "./DatePicker";
import CommentImg from "./CommentImg";
import HomeSplayer from "./HomeSplayer";
import MediumPlayer from "./MediumPlayer";
import AboutTeam from "./AboutTeam";
import EveryThingYouNeed from "./EveryThingYouNeed";
import FAQs from "./FAQs";
import Footer from "./Footer";
// import { popupModal } from "../atoms/atom";
import { useRecoilState } from "recoil";
import Popup from "./Popup";
import { Link } from "react-scroll";

const ContentCreators = () => {
  // const [open, setOpen] = useRecoilState(popupModal);

  useEffect(() => {
    AOS.init();
    // setTimeout(() => {
    //   setOpen(true);
    // }, 8000);
  }, []);

  return (
    <div className="bg-[#fff]">
      <Nav active="contentCreators" />
      <div className="max-w-[1320px] border-8 border-red-600 md:mx-auto mx-4 flex items-center justify-center  md:justify-between flex-wrap mt-10">
        <div
          data-aos="fade-right"
          data-aos-delay="200"
          data-aos-duration="1000"
          className=" flex-grow mx-auto max-w-[600px]"
        >
          <h1 className="sm:text-[48px] text-[40px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#1b0c3e]">
            THE Video Editing Service for Content Creators
          </h1>
          <p className="mt-4 text-2xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
            Serious content creator? Get your videos edited minus the burnout -
            without breaking the bank.
          </p>
          <p className="mt-8 text-2xl leading-9 text-[#4f4f4f]  text-center lg:text-left">
            {`Watch the first 2 minutes of this video. Click the button below to
            see if you qualify for Video Husky’s`}
            <span className="font-semibold"> $250 discounted rate. </span>
          </p>
          <div className="mt-4 mb-4 text-center lg:mb-0 md:mt-8 lg:text-left">
            <button className="md:p-4 m-1 p-3 md:mt-2 mt-1 mr-1 text-[#fff] bg-[#508dff] rounded-md md:text-xl text-lg font-semibold  transition duration-200 hover:shadow-2xl ease-out">
              See if you qualify
            </button>
          </div>
        </div>
        <div
          data-aos="fade-left"
          data-aos-delay="200"
          data-aos-duration="1000"
          className="flex-grow sm:min-w-[450px] min-w-[290px]  max-w-[591px] mx-auto  px-2 sm:px-4"
        >
          <Reactplayer url="https://www.youtube.com/watch?v=vNx2Z7ePCoM&t=4s" />
          <h1 className="hidden md:mt-24 md:block"></h1>
        </div>
      </div>
      <img
        data-aos="fade-up"
        data-aos-delay="200"
        data-aos-duration="1000"
        src={require("../images/mountain.png")}
        alt=""
        className="w-[100vw] h-80 hidden lg:block"
      />
      {/* <div className="-mt-40 bg-white">
        <div className="my-20 pt-36 max-w-[900px] mx-auto px-5">
          <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
            Who is this for? (and who not)
          </h1>
        </div>
        <div className=" max-w-[1320px] mx-auto flex justify-around xl:justify-between flex-wrap">
          <div className="flex-grow  max-w-[620px]">
            <h1 className="text-[21px] px-3 text-center  font-bold  mb-8  text-[#1b0c3e] mt-3 hover:opacity-80">
              Video Husky is a good fit if
            </h1>

            <div className="flex items-center justify-between p-6 ">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                Your videos are between 10-20 minutes long
              </p>
              <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                <CheckIcon className="w-6 h-6 text-green-600" />
              </div>
            </div>
            <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                Your typical raw footage size and running time is 20-40gb and
                30-60 minutes
              </p>
              <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                <CheckIcon className="w-6 h-6 text-green-600" />
              </div>
            </div>
            <div className="flex items-center justify-between p-6 ">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                You’re a content creator/make videos for yourself or your
                business
              </p>
              <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                <CheckIcon className="w-6 h-6 text-green-600" />
              </div>
            </div>
            <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                You think of your working relationship with an editor as a
                creative collaboration.
              </p>
              <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                <CheckIcon className="w-6 h-6 text-green-600" />
              </div>
            </div>
            <div className="flex items-center justify-between p-6 ">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                Have a clear vision of how you want your video to look like
              </p>
              <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                <CheckIcon className="w-6 h-6 text-green-600" />
              </div>
            </div>
            <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                You use stock animation and graphic templates.
              </p>
              <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                <CheckIcon className="w-6 h-6 text-green-600" />
              </div>
            </div>

            <div className="flex items-center justify-between p-6 ">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                You shoot your own footage and need a bit of stock footage and
                templates
              </p>
              <div className="bg-green-300 bg-opacity-80 rounded-full p-[2px]">
                <CheckIcon className="w-6 h-6 text-green-600" />
              </div>
            </div>
          </div>
          <div className="flex-grow max-w-[620px]">
            <h1 className="text-[21px] px-3 text-center  font-bold  mb-8  text-[#1b0c3e] mt-3 hover:opacity-80">
              Video Husky is NOT a good fit if
            </h1>
            <div className="flex items-center justify-between p-6 ">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                Your videos are longer than 20 minutes
              </p>
              <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                <XIcon className="w-5 h-5 text-red-500" />
              </div>
            </div>
            <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                Your typical raw footage size and running time is over 40gb and
                60 minutes.
              </p>
              <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                <XIcon className="w-5 h-5 text-red-500" />
              </div>
            </div>
            <div className="flex items-center justify-between p-6 ">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                You are an agency/make videos for businesses or other people
              </p>
              <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                <XIcon className="w-5 h-5 text-red-500" />
              </div>
            </div>
            <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                You prefer immediate interaction or micromanaging your video
                editor
              </p>
              <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                <XIcon className="w-5 h-5 text-red-500" />
              </div>
            </div>
            <div className="flex items-center justify-between p-6 ">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                You don’t know what your video should look like
              </p>
              <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                <XIcon className="w-5 h-5 text-red-500" />
              </div>
            </div>
            <div className="bg-[#f4f5f5] p-6 flex items-center justify-between">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                Your videos need custom animations and graphics.
              </p>
              <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                <XIcon className="w-5 h-5 text-red-500" />
              </div>
            </div>
            <div className="flex items-center justify-between p-6 ">
              <p className=" font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
                You rely only on stock footage
              </p>
              <div className="bg-red-300 bg-opacity-80 rounded-full p-[2px]">
                <XIcon className="w-5 h-5 text-red-500" />
              </div>
            </div>
          </div>
        </div>
        <div className="py-10 mt-8 text-center md:py-16">
          <Link
            to="calender"
            // spy={true}
            smooth={true}
            offset={-60}
            duration={700}
          >
            <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#1b0c3e] text-center mx-auto">
              Book a free consultation!
            </button>
          </Link>
        </div>
      </div> */}
      {/* <Price /> */}
      {/* <div className="overflow-x-scroll text-gray-400 bg-white py-28 scrollbar-hide">
        <img
          src={require("../images/brandList2.png")}
          className="max-w-[1320px] mx-auto  text-gray-400 h-[300px] xl:h-auto lg:h-[400px] filter grayscale opacity-60"
          alt=""
        />
      </div> */}

      {/* <div>
        <DatePicker />
      </div> */}

      {/* <div className="-mt-16 bg-white md:-mt-0">
        <OurClientsResults />
        <CommentImg img={require("../images/commentsImg1.png")} />
      </div> */}
      <div
        data-aos="fade-up"
        data-aos-delay="200"
        data-aos-duration="1000"
        className="border-8 border-red-600"
      >
        <h1 className="md:text-[43px] text-[30px] text-center  font-bold text-[#1b0c3e] py-3 mt-20">
          Example videos
        </h1>
        <h1 className=" text-[24px] text-center opacity-80 text-[#1b0c3e] mb-12">
          See what other content creators have produced with us...
        </h1>
        <div className="max-w-[1350px] mx-auto flex flex-wrap xl:justify-between justify-around">
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-w-[400px] m-4 my-6 ">
            <HomeSplayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-w-[400px] m-4 my-6">
            <HomeSplayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-w-[400px] m-4 my-6">
            <HomeSplayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-w-[400px] m-4 my-6">
            <HomeSplayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-w-[400px] m-4 my-6">
            <HomeSplayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] sm:max-w-[400px] m-4 my-6">
            <HomeSplayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          {/* <div className="flex-grow min-w-[300px] sm:min-w-[400px] max-w-[300px] m-4 my-6">
            <HomeSplayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow min-w-[300px] sm:min-w-[400px] max-w-[300px] m-4 my-6">
            <HomeSplayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div> */}
        </div>
        <div className="py-10 my-8 text-center md:py-16">
          <Link to="/category/case-studies">
            <button className="md:py-4 md:px-6 p-3 m-1 hover:shadow-2xl md:text-2xl text-xl font-semibold text-[#fff] bg-[#508dff] rounded-md transition duration-200 ease-out  text-center mx-auto">
              See what video editing we offer
            </button>
          </Link>
        </div>
      </div>
      <div className="bg-white">
        {/* <div className="w-full pt-24 pb-20 px-[20px] md:px-2  max-w-[1320px] mx-auto flex  flex-wrap justify-center xl:justify-between">
          <div className="flex-grow xl:max-w-[580px]  max-w-[700px]">
            <h1 className="md:text-[43px] text-[30px] text-center xl:text-left font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
              Video Husky lets you spend more time doing what you love –
              creating amazing content.
            </h1>
          </div>
          <div className="flex-grow max-w-[670px] ">
            <p className="mt-4 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
              There's no denying. Editing videos is often so tedious, it makes
              you feel like you're staring at the clock in a 2-hour school
              exam... but it's annoyingly necessary.
            </p>
            <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
              Your content deserves great editing, but spending hours doing it
              yourself sucks.
            </p>
            <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
              You didn't get into content creation for this...
            </p>
            <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
              You should be able to focus on giving value to your audience,
              without the shadow of an unfinished pile of footage looming over
              you.
            </p>
            <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
              If you're already stuck on a hamster wheel trying to get caught
              up, with too much footage to edit and not enough time to get
              through it all… it'll seem like there's no way out.
            </p>
          </div>
        </div> */}

        {/* <div className="py-2 pb-16 text-center">
          <Link to="/category/case-studies">
            <button className="md:py-4 md:px-6 p-3 m-1 text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#1b0c3e] text-center mx-auto">
              Book a free consultation!
            </button>
          </Link>
        </div> */}
      </div>
      <>
        {/* <div className="flex-grow mx-auto max-w-[680px] my-10 mt-20">
          <h1 className="sm:text-[48px] text-[40px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#1b0c3e]">
            There is a better way
          </h1>
          <h1 className=" text-[30px] text-center lg:text-left font-semibold text-[#1b0c3e] mt-6">
            Imagine...
          </h1>
        </div>
        <div className=" max-w-[700px] mx-auto flex flex-wrap justify-around">
          <div className="border m-2 my-4 md:min-w-[700px] md:max-w-[700px] p-4 bg-white flex flex-wrap items-center md:justify-start justify-around">
            <p className="max-w-[40px] text-2xl mx-4 mb-2">🙂</p>
            <div className="max-w-[580px]">
              <h1 className="text-[22px] text-center sm:text-left font-semibold  text-[#1b0c3e] ml-3">
                {`Finally releasing the overwhelming pressure of having to go through your editing backlog`}
              </h1>
            </div>
          </div>
          <div className="border m-2 my-4 md:min-w-[700px] md:max-w-[700px] p-4 bg-white flex flex-wrap items-center md:justify-start justify-around">
            <p className="max-w-[40px] text-2xl mx-4 mb-2">😀</p>
            <div className="max-w-[580px]">
              <h1 className="text-[22px] text-center sm:text-left font-semibold  text-[#1b0c3e] ml-3">
                {`Having more freedom to explore the creative ideas bubbling-up inside your head`}
              </h1>
            </div>
          </div>
          <div className="border m-2 my-4 md:min-w-[700px] md:max-w-[700px] p-4 bg-white flex flex-wrap items-center md:justify-start justify-around">
            <p className="max-w-[40px] text-2xl mx-4 mb-2">😆</p>
            <div className="max-w-[580px]">
              <h1 className="text-[22px] text-center sm:text-left font-semibold  text-[#1b0c3e] ml-3">
                {`How much more value your audience could get from your new ideas`}
              </h1>
            </div>
          </div>
          <div className="border m-2 my-4 md:min-w-[700px] md:max-w-[700px] p-4 bg-white flex flex-wrap items-center md:justify-start justify-around">
            <p className="max-w-[40px] text-2xl mx-4 mb-2">😍</p>
            <div className="max-w-[580px]">
              <h1 className="text-[22px] text-center sm:text-left font-semibold  text-[#1b0c3e] ml-3">
                {`Not having to worry about editing and just doing the fun side of content creation!`}
              </h1>
            </div>
          </div>
        </div>
        <div className="flex-grow mx-auto max-w-[680px] my-10 mt-20 pb-10">
          <h1 className=" text-[30px] text-center lg:text-left font-semibold text-[#1b0c3e] mt-6">
            Just a moment.
          </h1>
          <h1 className=" text-[20px] text-center lg:text-left  text-[#1b0c3e] mt-4 opacity-80">
            Let's break down our simple process to video editing here at Video
            Husky.
          </h1>
        </div>
        <div className="bg-white">
          <div className="flex-grow mx-auto max-w-[720px] my-4 mt-16 py-20">
            <h1 className="sm:text-[48px] text-[40px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#1b0c3e]">
              Wanna know how Video Husky works? Here's how
            </h1>
          </div>
          <div className=" max-w-[1320px] mx-auto flex flex-wrap justify-around xl:justify-between pb-24">
            <div className="p-8 md:p-5 my-4  max-w-[420px] border">
              <img
                src={require("../images/offload.png")}
                alt=""
                className="w-20 h-20 mx-auto mt-3 mb-9"
              />
              <h1 className="text-[22px] text-center font-semibold mb-3 text-[#1b0c3e] mt-3">
                {`Offload your assets to us`}
              </h1>
              <p className="mt-5 text-[18px] leading-8 text-[#52626f]  text-center">
                {`Join Video Husky and send us your footage and editing instructions in minutes.`}
              </p>
            </div>
            <div className="p-8 md:p-5 my-4  max-w-[420px] border">
              <img
                src={require("../images/firstDraft.png")}
                alt=""
                className="w-20 h-20 mx-auto mt-3 mb-9"
              />
              <h1 className="text-[22px] text-center font-semibold mb-3 text-[#1b0c3e] mt-3">
                {`Get your first draft in 1-2 business days`}
              </h1>
              <p className="mt-5  text-[18px] leading-8 text-[#52626f]  text-center">
                {`While we edit your video, you can finally put this time to better use.`}
              </p>
            </div>
            <div className="p-8 md:p-5 my-4 max-w-[420px] border">
              <img
                src={require("../images/revisions.png")}
                alt=""
                className="w-20 h-20 mx-auto mt-3 mb-9"
              />
              <h1 className="text-[22px] text-center font-semibold mb-3 text-[#1b0c3e] mt-3">
                {`Request any revisions, then start your next project!`}
              </h1>
              <p className="mt-5  text-[18px] leading-8 text-[#52626f]  text-center">
                {`Share your feedback with your editor. Once you’re happy, we’ll start your next video.`}
              </p>
            </div>
          </div>
        </div> */}
      </>
      {/* <div className="w-full pt-24 pb-20 px-[20px] md:px-2  max-w-[1320px] mx-auto flex  flex-wrap justify-center xl:justify-between">
        <div className="flex-grow xl:max-w-[580px]  max-w-[700px]">
          <h1 className="md:text-[43px] text-[30px] text-center xl:text-left font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
            Video Husky lets you spend more time doing what you love – creating
            amazing content.
          </h1>
        </div>
        <div className="flex-grow max-w-[670px] ">
          <p className="mt-4 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
            There's no denying. Editing videos is often so tedious, it makes you
            feel like you're staring at the clock in a 2-hour school exam... but
            it's annoyingly necessary.
          </p>
          <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
            Your content deserves great editing, but spending hours doing it
            yourself sucks.
          </p>
          <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
            You didn't get into content creation for this...
          </p>
          <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
            You should be able to focus on giving value to your audience,
            without the shadow of an unfinished pile of footage looming over
            you.
          </p>
          <p className="mt-7 text-2xl leading-9 text-[#52626f]  text-center xl:text-left">
            If you're already stuck on a hamster wheel trying to get caught up,
            with too much footage to edit and not enough time to get through it
            all… it'll seem like there's no way out.
          </p>
        </div>
      </div> */}
      {/* <div className="pb-20 text-center">
        <Link to="/category/case-studies">
          <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#1b0c3e] text-center mx-auto">
            Book a free consultation!
          </button>
        </Link>
      </div> */}
      {/* <div className="pt-24 bg-white">
        <CommentImg img={require("../images/commentsImg2.png")} />
        <div className="py-2 pb-16 text-center">
          <Link to="/category/case-studies">
            <button className="md:py-4 md:px-6 p-3 m-1 text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#1b0c3e] text-center mx-auto">
              Book a free consultation!
            </button>
          </Link>
        </div>
      </div> */}
      {/* <div className="flex-grow md:mx-auto max-w-[780px]  py-16 mx-4">
        <h1 className="sm:text-[48px] text-[40px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#1b0c3e] mb-12 mt-10">
          All the benefits of getting your video editing done for you, without
          having to hire or rely on a freelance or full-time editor.
        </h1>

        <p className="mt-4 text-xl leading-9 text-[#6e7c87] opacity-90 text-center lg:text-left">
          Hiring an editor is not as simple as just paying them once each month
          and letting them do the work for you.
        </p>
        <p className="mt-4 text-xl leading-9 text-[#6e7c87] opacity-90 text-center lg:text-left">
          Many creators have to go through a few different editors before they
          find one who's decent enough to keep on.
        </p>
        <p className="mt-4 text-xl leading-9 text-[#6e7c87]  text-center lg:text-left">
          That's after:
        </p>
        <p className="mt-4 text-xl leading-9 text-[#6e7c87]  text-center lg:text-left">
          <li>Searching through profiles</li>
        </p>
        <p className=" text-xl leading-9 text-[#6e7c87]  text-center lg:text-left">
          <li>Negotiating contracts</li>
        </p>
        <p className=" text-xl leading-9  text-[#6e7c87]  text-center lg:text-left">
          <li>Training the editor (if they're a new employee)</li>
        </p>
        <p className=" text-xl leading-9 text-[#6e7c87]  text-center lg:text-left">
          <li>Chasing up for videos</li>
        </p>
        <p className=" text-xl leading-9 text-[#6e7c87]  text-center lg:text-left">
          <li>Managing the projects</li>
        </p>
        <p className=" text-xl leading-9 text-[#6e7c87]  text-center lg:text-left">
          <li>Organizing all the project files</li>
        </p>
        <p className=" text-xl leading-9 mt-5 text-[#6e7c87]  text-center lg:text-left">
          How would you feel about having to go through all of that?...
        </p>
        <p className=" text-3xl font-semibold leading-9 mt-8 text-[#1b0c3e]  text-center lg:text-left">
          #thanksbutnothanks
        </p>
      </div> */}
      {/* <div className="text-center pb-28">
        <Link to="/category/case-studies">
          <button className="md:py-4 md:px-6 p-3 m-1 text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#1b0c3e] text-center mx-auto">
            Book a free consultation!
          </button>
        </Link>
      </div> */}
      {/* <div className="bg-white">
        <div
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="1000"
          className="my-12 max-w-[1000px] mx-auto px-5 pt-20 pb-[1px]"
        >
          <h1 className="md:text-[43px] text-[30px] text-center  font-bold md:leading-[60px] mb-8 leading-[40px] text-[#1b0c3e] mt-3">
            Simple 3-step solution to outsource editing
          </h1>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="1000"
          className="max-w-[1320px] my-20 md:mt-36 mt-28 mx-auto px-4 flex lg:justify-between justify-around flex-wrap"
        >
          <div className="flex-grow max-w-[600px] mb-12">
            <h1 className=" md:text-[26px]  text-[22px] text-center lg:text-left  font-bold mb-8  text-[#1b0c3e] mt-3">
              {`BE ASSIGNED A HANDPICKED, PRE-VETTED PROFESSIONAL EDITING TEAM ON YOUR NEEDS`}
            </h1>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#52626f]  text-center lg:text-left opacity-80">
              {`Regain momentum through letting us take the headaches out of finding good freelance video editors by assigning you a handpicked professional editor based on the kinds of videos that you need to have edited to pick from so you can build chemistry for the get-go.`}
            </p>
          </div>
          <div className="flex-grow max-w-[540px] mb-6">
            <img src={require("../images/3stepesImg1.png")} alt="" />
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="1000"
          className="max-w-[1320px] my-20 mx-auto px-4 flex lg:justify-between justify-around flex-wrap"
        >
          <div className="flex-grow max-w-[540px] mb-6">
            <img src={require("../images/3stepesImg2.png")} alt="" />
          </div>
          <div className="flex-grow max-w-[600px]">
            <h1 className=" md:text-[26px]  text-[22px] text-center lg:text-left  font-bold mb-8  text-[#1b0c3e] mt-3">
              {`BE ASSIGNED A HANDPICKED, PRE-VETTED PROFESSIONAL EDITING TEAM ON YOUR NEEDS`}
            </h1>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#52626f]  text-center lg:text-left opacity-80">
              {`Frustrated by missing files and miscommunication? Relax knowing that you submit, revise, and download videos all from one place while using our Video Proofing tool to leave feedback directly on the video to avoid mistakes that eat up additional time and effort.`}
            </p>
          </div>
        </div>
        <div
          data-aos="fade-up"
          data-aos-delay="200"
          data-aos-duration="1000"
          className="max-w-[1320px] my-20 md:mt-36 mt-28 mx-auto px-4 flex lg:justify-between justify-around flex-wrap"
        >
          <div className="flex-grow max-w-[600px] mb-12">
            <h1 className=" md:text-[26px]  text-[22px] text-center lg:text-left  font-bold mb-8  text-[#1b0c3e] mt-3">
              {`BE ASSIGNED A HANDPICKED, PRE-VETTED PROFESSIONAL EDITING TEAM ON YOUR NEEDS`}
            </h1>
            <p className="mt-5 md:text-[21px] text-[18px] leading-9 text-[#52626f]  text-center lg:text-left opacity-80">
              {`Got a huge backlog of videos? Fill out and send over as many briefing forms as you would like. We’ll work on one active project at a time.`}
            </p>
          </div>
          <div className="flex-grow max-w-[540px] mb-6">
            <img src={require("../images/3stepesImg3.png")} alt="" />
          </div>
        </div>
        <div className="py-10 pb-24 my-8 text-center">
          <Link to="/category/case-studies">
            <button className="md:py-4 md:px-6 p-3 m-1  text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#2d3339] text-center mx-auto">
              Book a free consultation
            </button>
          </Link>
        </div>
      </div> */}
      {/* <div className="pb-24 bg-black bg-opacity-95 -mt-9">
        <h1 className="md:text-[43px] text-[30px] text-center  font-bold text-white pt-28 pb-16">
          What our customers say about us
        </h1>
        <div className="max-w-[1350px] mx-auto flex flex-wrap xl:justify-between justify-around">
          <div className="flex-grow sm:min-w-[400px] min-w-[300px] max-w-[400px] m-4 my-6">
            <MediumPlayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow sm:min-w-[400px] min-w-[300px] max-w-[400px] m-4 my-6 ">
            <MediumPlayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow sm:min-w-[400px] min-w-[300px] max-w-[400px] m-4 my-6 ">
            <MediumPlayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow sm:min-w-[400px] min-w-[300px] max-w-[400px] m-4 my-6 ">
            <MediumPlayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow sm:min-w-[400px] min-w-[300px] max-w-[400px] m-4 my-6 ">
            <MediumPlayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow sm:min-w-[400px] min-w-[300px] max-w-[400px] m-4 my-6 ">
            <MediumPlayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow sm:min-w-[400px] min-w-[300px] max-w-[400px] m-4 my-6 ">
            <MediumPlayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow sm:min-w-[400px] min-w-[300px] max-w-[400px] m-4 my-6 ">
            <MediumPlayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
          <div className="flex-grow sm:min-w-[400px] min-w-[300px] max-w-[400px] m-4 my-6 ">
            <MediumPlayer url="https://www.youtube.com/watch?v=yPTgyBhJJPs" />
          </div>
        </div>
      </div> */}
      {/* <AboutTeam />
      <EveryThingYouNeed />
      <div className="pt-40 -mt-8 bg-white">
        <CommentImg img={require("../images/commentsImg3.png")} />
      </div>
      <FAQs
        heading="Smart questions people like you have asked before freeing themselves
          from the burden of editing."
      /> */}
      {/* <div className="flex-grow mx-auto max-w-[680px] my-10 mt-20">
        <h1 className="sm:text-[48px] text-[40px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#1b0c3e]">
          You'll love Video Husky if...
        </h1>
      </div> */}
      {/* <div className=" max-w-[830px] mx-auto flex flex-wrap justify-around">
        <div className="border m-2 my-4 lg:min-w-[830px] lg:max-w-[830px] p-4 bg-white flex flex-wrap items-center lg:justify-start justify-around">
          <p className="max-w-[40px] text-2xl mx-4 mb-2">🙁</p>
          <div className="max-w-[710px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold  text-[#1b0c3e] ml-3">
              {`You're stuck in a bottleneck with too much footage and no way to get it all edited`}
            </h1>
          </div>
        </div>
        <div className="border m-2 my-4 lg:min-w-[830px] lg:max-w-[830px] p-4 bg-white flex flex-wrap items-center lg:justify-start justify-around">
          <p className="max-w-[40px] text-2xl mx-4 mb-2">😐</p>
          <div className="max-w-[710px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold  text-[#1b0c3e] ml-3">
              {`You're tired of grinding away on the back-end work of producing videos`}
            </h1>
          </div>
        </div>
        <div className="border m-2 my-4 lg:min-w-[830px] lg:max-w-[830px] p-4 bg-white flex flex-wrap items-center lg:justify-start justify-around">
          <p className="max-w-[40px] text-2xl mx-4 mb-2">😬</p>
          <div className="max-w-[710px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold  text-[#1b0c3e] ml-3">
              {`You feel like a child again when you do creatives and you want to do more`}
            </h1>
          </div>
        </div>
        <div className="border m-2 my-4 lg:min-w-[830px] lg:max-w-[830px] p-4 bg-white flex flex-wrap items-center lg:justify-start justify-around">
          <p className="max-w-[40px] text-2xl mx-4 mb-2">😛</p>
          <div className="max-w-[710px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold  text-[#1b0c3e] ml-3">
              {`You have ideas for game-changing content that you're dying to release`}
            </h1>
          </div>
        </div>
        <div className="border m-2 my-4 lg:min-w-[830px] lg:max-w-[830px] p-4 bg-white flex flex-wrap items-center lg:justify-start justify-around">
          <p className="max-w-[40px] text-2xl mx-4 mb-2">😓</p>
          <div className="max-w-[710px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold  text-[#1b0c3e] ml-3">
              {`You want to give more value and improve the lives of your audience`}
            </h1>
          </div>
        </div>
        <div className="border m-2 my-4 lg:min-w-[830px] lg:max-w-[830px] p-4 bg-white flex flex-wrap items-center lg:justify-start justify-around">
          <p className="max-w-[40px] text-2xl mx-4 mb-2">😭</p>
          <div className="max-w-[710px]">
            <h1 className="text-[22px] text-center sm:text-left font-semibold  text-[#1b0c3e] ml-3">
              {`Looking at your pile of footage to edit, you're worried about burning out`}
            </h1>
          </div>
        </div>
      </div> */}
      {/* <div className="pt-12 pb-32 text-center">
        <Link to="/category/case-studies">
          <button className="md:py-4 md:px-6 p-3 m-1  text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#2d3339] text-center mx-auto">
            Book a free consultation
          </button>
        </Link>
      </div> */}
      <div className="flex border-8 border-red-600 mx-auto items-center justify-around xl:justify-between flex-wrap max-w-[1320px] bg-[#1b0c3e] rounded-md md:p-20 p-6">
        <h1 className="max-w-[560px]  text-2xl font-semibold md:text-left text-center mb-6 md:mb-0 mt-2 md:mt-0 text-[#fff]">
          Join hundreds of other video creators like you. Find out if you
          qualify for Video Husky's special discount rate!
        </h1>
        <button className="md:py-4 md:px-7 p-3 m-1  text-xl font-semibold text-[#fff] bg-[#508dff] rounded-md">
          Book a free consultation
        </button>
      </div>
      <>
        {/* <div className="flex-grow mx-auto max-w-[860px]  pt-36 pb-4 px-5 md:px-0">
          <h1 className="sm:text-[46px] text-[40px] max-w-[830px] text-center lg:text-left font-bold md:leading-[60px] leading-[50px] text-[#1b0c3e]">
            How much time do you save with Video Husky?
          </h1>
          <h1 className="pb-4 text-[25px] text-center lg:text-left font-semibold text-[#1b0c3e] mt-6">
            You save hundreds of collective hours by not doing your own video
            editing:
          </h1>
        </div>
        <div className=" max-w-[880px] mx-auto flex flex-wrap xl:justify-between justify-around">
          <div className="border m-2 my-4 md:min-w-[400px] min-w-[275px] md:max-w-[400px] p-6 bg-white flex flex-wrap justify-around md:justify-start items-center">
            <img
              src={require("../images/cutting.jpg")}
              alt=""
              className="w-12 h-12 mr-6"
            />
            <div className="">
              <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3 ">
                {`Cutting`}
              </h1>
            </div>
          </div>
          <div className="border m-2 my-4 md:min-w-[400px] md:max-w-[400px] min-w-[275px] p-6 bg-white flex flex-wrap justify-around md:justify-start items-center">
            <img
              src={require("../images/knife.png")}
              alt=""
              className="w-12 h-12 mr-6"
            />
            <div className="">
              <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3 ">
                {`Splicing`}
              </h1>
            </div>
          </div>
          <div className="border m-2 my-4 md:min-w-[400px] md:max-w-[400px] p-6 bg-white min-w-[275px] flex flex-wrap justify-around md:justify-start items-center">
            <img
              src={require("../images/colorPicker.png")}
              alt=""
              className="w-12 h-12 mr-6"
            />
            <div className="">
              <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3 ">
                {`Color correction`}
              </h1>
            </div>
          </div>
          <div className="border m-2 my-4 md:min-w-[400px] md:max-w-[400px] p-6 bg-white flex flex-wrap min-w-[275px] justify-around md:justify-start items-center">
            <img
              src={require("../images/audio.png")}
              alt=""
              className="w-12 h-12 mr-6"
            />
            <div className="">
              <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3 ">
                {`Fixing audio`}
              </h1>
            </div>
          </div>
          <div className="border m-2 my-4 md:min-w-[400px] md:max-w-[400px] p-6 bg-white flex flex-wrap justify-around min-w-[275px] md:justify-start items-center">
            <img
              src={require("../images/subtitles.png")}
              alt=""
              className="w-12 h-12 mr-6"
            />
            <div className="">
              <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3 ">
                {`Adding subtitles`}
              </h1>
            </div>
          </div>
          <div className="border m-2 my-4 md:min-w-[400px] md:max-w-[400px] p-6 bg-white flex flex-wrap justify-around md:justify-start min-w-[275px] items-center">
            <img
              src={require("../images/animations.png")}
              alt=""
              className="w-12 h-12 mr-6"
            />
            <div className="">
              <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3 ">
                {`Transitions`}
              </h1>
            </div>
          </div>
        </div>
        <div className="flex-grow mx-auto max-w-[860px] pt-3   pb-4 px-5 md:px-0">
          <h1 className="pb-4 text-[25px] text-center lg:text-left font-semibold text-[#1b0c3e] mt-6">
            You save countless hours by not doing it the old-fashioned way with
            freelancers or full-time editors:
          </h1>
        </div>
        <div className=" max-w-[880px] mx-auto flex flex-wrap xl:justify-between justify-around">
          <div className="border m-2 my-4 md:min-w-[400px] min-w-[275px] md:max-w-[400px] p-6 bg-white flex flex-wrap justify-around md:justify-start items-center">
            <img
              src={require("../images/searching.png")}
              alt=""
              className="w-12 h-12 mr-6"
            />
            <div className="">
              <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3 ">
                {`Searching`}
              </h1>
            </div>
          </div>
          <div className="border m-2 my-4 md:min-w-[400px] md:max-w-[400px] min-w-[275px] p-6 bg-white flex flex-wrap justify-around md:justify-start items-center">
            <img
              src={require("../images/hiring.png")}
              alt=""
              className="w-12 h-12 mr-6"
            />
            <div className="">
              <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3 ">
                {`Hiring`}
              </h1>
            </div>
          </div>
          <div className="border m-2 my-4 md:min-w-[400px] md:max-w-[400px] p-6 bg-white min-w-[275px] flex flex-wrap justify-around md:justify-start items-center">
            <img
              src={require("../images/training.png")}
              alt=""
              className="w-12 h-12 mr-6"
            />
            <div className="">
              <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3 ">
                {`Training`}
              </h1>
            </div>
          </div>
          <div className="border m-2 my-4 md:min-w-[400px] md:max-w-[400px] p-6 bg-white flex flex-wrap min-w-[275px] justify-around md:justify-start items-center">
            <img
              src={require("../images/managing.png")}
              alt=""
              className="w-12 h-12 mr-6"
            />
            <div className="">
              <h1 className="text-[22px] text-center sm:text-left font-semibold mb-1 text-[#1b0c3e] mt-3 ">
                {`Managing`}
              </h1>
            </div>
          </div>
        </div>
        <div className="flex-grow mx-auto max-w-[860px] pt-3   pb-4 px-5 md:px-0">
          <h1 className="pb-4 text-[25px] text-center lg:text-left font-semibold text-[#1b0c3e] mt-9">
            Imagine not doing ANY of the above while STILL producing on-brand
            videos you can be proud of...
          </h1>
          <h1 className="pb-4 text-[20px] text-center lg:text-left  text-[#1b0c3e] mt-5">
            Not only that, but then getting your content published on a
            consistent basis…
          </h1>
          <h1 className="pb-4 text-[20px] text-center lg:text-left  text-[#1b0c3e] mt-1">
            Other content creators will want to know how you do it!
          </h1>
          <h1 className="pb-4 text-[20px] text-center lg:text-left  text-[#1b0c3e] mt-1">
            With Video Husky, you’ll be up-and-running with a full video editing
            team. And when you are, you reap the rewards:
          </h1>
        </div>
        <div className="mx-auto max-w-[860px]">
          <div className="flex items-center py-5">
            <div className="bg-green-300 bg-opacity-80 mr-5 rounded-full p-[2px]">
              <CheckIcon className="w-6 h-6 text-green-600" />
            </div>
            <p className="font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
              Releasing that overwhelming pressure to get through your editing
              backlog
            </p>
          </div>
          <hr />
          <div className="flex items-center py-5">
            <div className="bg-green-300 bg-opacity-80 mr-5 rounded-full p-[2px]">
              <CheckIcon className="w-6 h-6 text-green-600" />
            </div>
            <p className="font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
              Getting more leisure time and enjoying it more with one less thing
              to worry about
            </p>
          </div>
          <hr />
          <div className="flex items-center py-5">
            <div className="bg-green-300 bg-opacity-80 mr-5 rounded-full p-[2px]">
              <CheckIcon className="w-6 h-6 text-green-600" />
            </div>
            <p className="font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
              Getting more joy out of creating content with freedom to explore
              your creative side
            </p>
          </div>
          <hr />
          <div className="flex items-center py-5">
            <div className="bg-green-300 bg-opacity-80 mr-5 rounded-full p-[2px]">
              <CheckIcon className="w-6 h-6 text-green-600" />
            </div>
            <p className="font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
              Using your skills and focusing your expertise to create better,
              more unique content
            </p>
          </div>
          <hr />
          <div className="flex items-center py-5">
            <div className="bg-green-300 bg-opacity-80 mr-5 rounded-full p-[2px]">
              <CheckIcon className="w-6 h-6 text-green-600" />
            </div>
            <p className="font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
              Pursuing held-back ideas to reach your full potential as a content
              creator
            </p>
          </div>
          <hr />
          <div className="flex items-center py-5">
            <div className="bg-green-300 bg-opacity-80 mr-5 rounded-full p-[2px]">
              <CheckIcon className="w-6 h-6 text-green-600" />
            </div>
            <p className="font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
              Connecting with your audience on a deeper level and giving them
              more value
            </p>
          </div>
          <hr />
          <div className="flex items-center py-5">
            <div className="bg-green-300 bg-opacity-80 mr-5 rounded-full p-[2px]">
              <CheckIcon className="w-6 h-6 text-green-600" />
            </div>
            <p className="font-semibold text-[#1b0c3e] text-[18px] max-w-[87%]">
              No longer worrying about boring video editing and just doing the
              fun side of creating content!
            </p>
          </div>
          <hr />
        </div>

        <div className="pt-12 pb-32 text-center">
          <Link to="/category/case-studies">
            <button className="md:py-4 md:px-6 p-3 m-1  text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#2d3339] text-center mx-auto">
              Book a free consultation
            </button>
          </Link>
        </div> */}
      </>
      <Popup />
      <Footer />
    </div>
  );
};

export default ContentCreators;

// font-family: "Avenir Next","Helvetica Neue","HelveticaNeue",Helvetica,Arial,sans-serif;
